import {showNotification} from 'platform/components';

import {uniq} from 'ramda';
import {isNotNilOrEmpty, isString} from 'ramda-adjunct';

import {
  MazdaClaimMessage,
  PostServiceOrderIntegrationsMazdaClaimSendApiResponse,
} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

const isNonEmptyDescription = (description: string | Nullish): description is string =>
  isNotNilOrEmpty(description);

// Mazda's text is proxied unvalidated: the response schema only warns in dev, so a null entry or a
// non-string description would throw here and turn an accepted claim into a reported failure.
const toDescription = (message: MazdaClaimMessage | Nullish) => {
  const description = message?.description;

  return isString(description) ? description.trim() : null;
};

const getDescriptions = (messages: MazdaClaimMessage[] | Nullish) =>
  uniq((messages ?? []).map(toDescription).filter(isNonEmptyDescription));

// Mazda can accept a claim and still flag it. An empty array would render a blank toast.
export const notifyMazdaClaimSendMessages = (
  response: PostServiceOrderIntegrationsMazdaClaimSendApiResponse
) => {
  const warnings = getDescriptions(response?.warnings);
  const errors = getDescriptions(response?.errors);

  if (isNotNilOrEmpty(warnings)) {
    showNotification.warning(warnings);
  }

  if (isNotNilOrEmpty(errors)) {
    showNotification.error(errors);
  }
};
